<template>
    <div class="scrollableY " >
       <div class="homePage">
            <div class="container">
                <div>
                    <br>
                    <div class="columns  bottom80" :class="{'top80': !$root.app.inApp, 'top3': $root.app.inApp}">
                        <div class="column">
                            <div class="yellTitle limitWidth2" >
                                Finally, a new way to master your online brain.
                            </div>
                            <div class="limitWidth2">   
                                <div class="subText top40">
                                    <div><b>Need help organizing your online life? It can be a mess. We get it. </b></div>
                                    
                                </div>
        
                                <div class="subText top40">
                                   
                                    <div>Miimu converts your online nuggets into smart links with unlimited flexibility.</div>
                                </div>
                            </div>
    
                            <div class="yellTitle top60">
                                <b>miimu it!</b>
                            </div>
    
                            <div class="homeBlackRectangle top30 handCursor" @click="showLogin">
                             
                                <div><b>Sign up</b> to get started!</div>
                            </div>
    
                        </div>
    
                        <div class="column">
                            <img src="@/assets/img/Home.gif" class="top20"/>
                            <!-- <img src="@/assets/img/phone.png" class="right20" width="150" style="position: absolute; top: 310px; right: 80px" /> -->
                            
                            
                        </div>

                       
                    </div>
                    <div class="top80">&nbsp;</div>
                </div>
            </div>
       </div>


       <div class="has-background-azBlack homePage">
            <div class="container">
                <div>
                    <br>
                    <div class="top40 has-text-centered">
                       
                            
                        <div class="top40">
                            <div class="midTitle has-text-white"><b>Capture</b> your stuff.</div>
                        </div>
                        
                        <div class="wideLimitWidth2 marginAutod has-text-white is-size-4 top20 homeTextBlock">
                            <div class="top20 has-text-coolGreen is-size-3 yellowLine"><b>miimus</b> are intelligent links to your content:</div>
                            <div class="whiteLine">Save web pages, IG posts, videos and more.</div>
                            <div class="whiteLine">Then, customize them with graphics, notes, and tags.</div>
                            <div class="has-text-coolGreen top10 bottom10"><b>Make it your own!</b></div>
                        </div>
                        <div class="homeImgContainer"><img class="gif" src="@/assets/img/Capture2.gif" /></div>

                        <div class="mobileVertSpacer">
                            <div class="midTitle has-text-white"><b>Bundle</b> it all.</div>
                        </div>
                        <div class="wideLimitWidth2  marginAutod has-text-white is-size-4 top20 homeTextBlock">
                            <div class="top20 is-size-3 has-text-coolGreen yellowLine"><b>Bundles</b> are collections of miimus.</div>
                            <div class="whiteLine">Organize them to your liking, with limitless options.</div>
                          
                            <div class="has-text-coolGreen top10 bottom5"><b>The possibilities are endless!</b></div>
                        </div>
                        <img class="gif" src="@/assets/img/Bundle.gif" />

                        <div class="mobileVertSpacer">
                            <div class="midTitle has-text-white"><b>Share</b> with everyone.</div>
                        </div>
                        <div class="has-text-white is-size-4 top20 homeTextBlock">
                            <div class="top20 has-text-coolGreen is-size-3 yellowLine"><b>No need to gatekeep.</b> Unless you want to.</div>
                            <div class="wideLimitWidth2 marginAutod whiteLine">Miimuers can share miimus and bundles with the world, through collaborations and good old fashioned email.</div>
                            <div class="has-text-coolGreen top10"><b>Spread the love!</b></div>
                        </div>
                        <img class="gif " src="@/assets/img/Share.gif" />

                       <div class="has-text-centered">
                            <div class="homeBlackRectangle top60 marginAutod handCursor" @click="showLogin">
                                 <div><b>Sign up</b> to get started!</div>
                             </div>
                       </div>

                    </div>
                    <div class="top80">&nbsp;</div>
                </div>
            </div>
       </div>


       <div class="has-background-grey-dark homePage">
            <div class="container">
                <div>
                    <br>
                    <div class="top80 has-text-centered">
                        <div class="columns">
                            <div class="column has-text-right makeCentered">
                                <img src="@/assets/img/phone.png"  />
                            </div>
                            
                            <div class="column has-text-left makeCentered">
                                <div class="homeMobileDiv">
                                    <div class="has-text-left">
                                        <img src="@/assets/img/Miimu logo.png" width="200" class="inlineLogo" /> <span class="yellTitle"> mobile!</span>
                                    </div>
                                    <div class="has-text-white is-size-4 has-text-left">
                                        <b>Download our app for iOS </b>
                                    </div>
                                    <div class="has-text-left">
                                        <a href="https://apps.apple.com/us/app/miimu/id6443739025"><img class="top5" width="135" src="@/assets/img/appStore.png" /></a>
                                    </div>


                                    <div class="top60 has-text-left">
                                        <img src="@/assets/img/Miimu logo.png" width="200" class="inlineLogo" /> <span class="yellTitle"> extension!</span>
                                    </div>
                                    <div class="has-text-white is-size-4 has-text-left">
                                        <b>Download our chrome extension for PC and Mac </b>
                                    </div>
                                    <div class="has-text-left">
                                        <a href="https://chromewebstore.google.com/detail/miimu/dafibmjgiefkgelgfgceicadkhllfghi"><img class="top5" width="135" src="@/assets/img/chromeStore.png" /></a>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        <div class="top60">&nbsp;</div>
                    </div>
                </div>
            </div>
        </div>




        <div class="has-background-dark homePage" id="contactForm">
            <div class="container">
                <div>
                    <br>
                    <div class="top80 has-text-centered has-text-white">
                        <div class="midTitle "><b>Don't be a stranger</b></div>
                        <div class="top10 is-size-5 has-text-coolGreen"><b>We'd love to hear from you.</b></div>
                        <div class=" is-size-5">info@miimu.com</div>
                        <div v-show="showThanks" class="top20 has-text-bold is-size-5">Thank you! Your message has been sent.</div>
                        

                        <br/>
                        <div class="wideLimitWidth marginAutod ">
                            <div class="field" >
                       
                                <input  type="text" placeholder="Name" class="input azTextInput phWhite" name="Name"  v-model="name" />

                            </div>
                            <div class="field posRelative" >
                                <input  type="text" placeholder="Email" class="input azTextInput" name="Email"  v-model="email" />
                               
                            </div>
                            <div class="field posRelative" >
                                <input  type="text" placeholder="Subject" class="input azTextInput" name="Subject"  v-model="subject" />
                               
                            </div>

                            <div class="field posRelative" >
                                <textarea   placeholder="Message" class="input azTextInput" name="Message"  v-model="message" rows="5" style="height: 150px" ></textarea>
                            </div>

                            <button class="button is-coolGreen top10" @click="sendEmail">SUBMIT</button>
                        </div>


                    </div>
                    <div class="top80">&nbsp;</div>
                </div>
            </div>
        </div>

        <footerdiv></footerdiv>


    </div>
</template>

<script>

import Footerdiv from '../components/Footer.vue'

export default{
    name: 'newhome',
    components: {Footerdiv},

    data: function(){
        return {
            name: '',
            email: '',
            subject: '',
            message: '',
            showThanks: false
        }

    },

    mounted: function(){
        document.getElementById('app').classList.add('bgImg')
    },

    beforeDestroy: function(){
        document.getElementById('app').classList.remove('bgImg')
    },

    methods: {

        sendEmail: function(){
            var self = this;

            function w(d){
                self.showThanks = true
                self.name = '',
                self.email = '',
                self.subject = '',
                self.message = ''
            }

            function n(){

            }

            if(this.name == '' || this.email == '' || this.subject == '' || this.message == ''){
                this.$root.app.showModalOK({message: 'All fields are required'})
                return
            }

            this.$root.app.apiClient.post('open/confirm/contact', {name: this.name, email: this.email, subject: this.subject, message: this.message}, w, n)
        },

        showLogin: function(){
            if(!this.$root.app.inApp)
                this.$router.push('/pricing')
            else
                this.$router.push('/register')
        }


    }


}


</script>